<template>
	<PageContainer size="xl">
		<VStepper
			v-if="!($route.fullPath.split('/')[2] === 'confirm')"
			v-model="currentStep"
			flat
		>
			<VStepperHeader>
				<template v-for="(item, index, i) in stepperItems">
					<VStepperStep
						:key="index"
						:step="i + 1"
						:complete="maxStep > i + 1"
						:style="{'cursor': i + 1 <= maxStep ? 'pointer' : 'default'}"
						@click="changeStep(i + 1)"
					>
						{{ item }}
					</VStepperStep>
					<VDivider
						v-if="i !== stepperItems.length - 1"
						:key="i + '0'"
					/>
				</template>
			</VStepperHeader>
		</VStepper>
		<router-view
			name="register"
			@set-step="setStep"
		/>
	</PageContainer>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { mapState } from 'vuex';

	@Component<Register>({
		computed: {
			...mapState('appState', ['user'])
		}
	})
	export default class Register extends Vue {
		currentStep = 1;
		maxStep = 1;
		stepperItems: string[] = [];

		created(): void {
			this.stepperItems = this.$t('views.register.stepper') as unknown as string[];
		}

		changeStep(step: number): void {
			const steps: { [key: number]: string } = {
				0: 'registerInformation',
				1: 'registerIdentification',
				2: 'registerDocument',
				3: 'registerValidation'
			};
			if (step <= this.maxStep && this.$route.name !== steps[step - 1]) {
				this.$router.push({ name: steps[step - 1] });
			}
		}

		setStep(step: number): void {
			window.scroll(0, 0);
			if (!this.user.rules || !this.user.rules.eligible) {
				this.$router.push({ path: '/' });
			}
			if (step > this.stepperItems.length) {
				this.currentStep = this.stepperItems.length;
			} else if (step < 1) {
				this.currentStep = 1;
			} else {
				this.currentStep = step;
			}
			this.maxStep = Math.max(this.maxStep, this.currentStep);
		}
	}
</script>
